export const bySex = (sex, { femmina, maschio, other }) => {
  if (sex === "femmina") return femmina;
  if (sex === "maschio") return maschio;
  return other;
};
